import React from 'react';
import breakpoints from '@99designs/asimov/platform-settings/settings/breakpoints';
import Responsive from 'react-responsive';

export const Desktop = ({ children, values }) => {
    return (
        <Responsive
            minWidth={breakpoints.normal[0]}
            children={children}
            values={values}
        />
    );
};



// WEBPACK FOOTER //
// ./~/@99designs/globalnav/src/components/breakpoints.jsx